<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
};
</script>

<style lang="less">
/* 全局字体 */
body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "Microsoft YaHei", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* 全局覆盖 Element UI 主题色 */
.el-button--primary {
  background-color: var(--brand-primary) !important;
  border-color: var(--brand-primary) !important;
}

.el-button--primary:hover,
.el-button--primary:focus {
  background-color: var(--brand-primary-strong) !important;
  border-color: var(--brand-primary-strong) !important;
}

.el-button--primary.is-plain {
  color: var(--brand-primary) !important;
  background: var(--brand-primary-soft) !important;
  border-color: var(--brand-primary-border) !important;
  &:hover, &:focus {
    background: var(--brand-primary) !important;
    color: #fff !important;
    border-color: var(--brand-primary) !important;
  }
}

.el-tag--dark {
  background-color: var(--brand-primary) !important;
  border-color: var(--brand-primary) !important;
}

/* Element UI 链接色 */
.el-link--primary {
  color: var(--brand-primary) !important;
  &:hover {
    color: var(--brand-primary-strong) !important;
  }
}

/* Element UI 分页选中色 */
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: var(--brand-primary) !important;
}

/* Element UI 输入框 focus 色 */
.el-input__inner:focus,
.el-textarea__inner:focus {
  border-color: var(--brand-primary) !important;
}

/* Element UI Switch 选中色 */
.el-switch.is-checked .el-switch__core {
  border-color: var(--brand-primary) !important;
  background-color: var(--brand-primary) !important;
}

/* Element UI Checkbox 选中色 */
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: var(--brand-primary) !important;
  border-color: var(--brand-primary) !important;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: var(--brand-primary) !important;
}

/* Element UI Radio 选中色 */
.el-radio__input.is-checked .el-radio__inner {
  background-color: var(--brand-primary) !important;
  border-color: var(--brand-primary) !important;
}
.el-radio__input.is-checked + .el-radio__label {
  color: var(--brand-primary) !important;
}

/* Element UI Select 选中色 */
.el-select .el-input.is-focus .el-input__inner {
  border-color: var(--brand-primary) !important;
}
.el-select-dropdown__item.selected {
  color: var(--brand-primary) !important;
}

/* Element UI Tabs 选中色 */
.el-tabs__item.is-active {
  color: var(--brand-primary) !important;
}
.el-tabs__active-bar {
  background-color: var(--brand-primary) !important;
}

/* Element UI Steps 选中色 */
.el-step__head.is-finish {
  color: var(--brand-primary) !important;
  border-color: var(--brand-primary) !important;
}
.el-step__title.is-finish {
  color: var(--brand-primary) !important;
}

/* Element UI Dropdown 下拉菜单 */
.el-dropdown-menu {
  border-radius: var(--radius-lg);
  border: 1px solid var(--surface-border);
  box-shadow: var(--shadow-md);
  padding: 6px 0;
}
.el-dropdown-menu__item {
  font-size: 14px !important;
  color: var(--text-secondary) !important;
  padding: 10px 20px !important;
  line-height: 1.4 !important;
  transition: all var(--transition-fast);
}
.el-dropdown-menu__item:hover {
  background: var(--brand-primary-soft) !important;
  color: var(--brand-primary) !important;
}
.el-dropdown-menu__item.dropdown-logout-item {
  margin-top: 6px;
  border-top: 1px solid var(--surface-border);
}
.el-dropdown-menu__item--divided::before {
  display: none !important;
}
.el-dropdown-menu__item--divided {
  margin-top: 6px !important;
  border-top: 1px solid var(--surface-border) !important;
}

/* 代码编辑器字体 */
.code-editor {
  font-family: 'JetBrains Mono', 'Fira Code', 'Consolas', '微软雅黑', 'Microsoft YaHei', monospace;
}

.mb15 {
  margin-bottom: 15px;
}
</style>
